import { ActionType } from '@common/enums/command-hub/command-buttons';
import { ActionStatus } from '@common/interfaces/robot/buttons/command-buttons';

interface ActionsList {
  actionList: ActionStatus[];
  actionReceived: ActionType;
  error: string | null;
}

export const isActionsList = (input: any): input is ActionsList => {
  return 'actionList' in input && 'actionReceived' in input && 'error' in input;
};

export default ActionsList;
